// Builder fee config — charged on every order and sent to the builder address.
// Fee rate is in tenths of a basis point: 50 = 0.05% (5bps) of order notional. Max 100 for perps.
// Set to true once the builder account is funded and ready to receive fees.
export const BUILDER_ENABLED = true;
export const BUILDER_ADDRESS =
	"0x8eEB81B32b4f1AA39eb3432AfDEBB18E7E9e21bE" as const;
export const BUILDER_FEE = 50;
export const BUILDER_FEE_RATE = "0.05%";

// Referral code — automatically set for users who don't have a referrer yet.
// MUST match the code registered on-chain by BUILDER_ADDRESS ("TENBEGGER" —
// "TENBAGGER" is owned by an unrelated third party, so pointing there leaks
// referral rewards; verified via HL referral state 2026-07-29).
export const REFERRAL_CODE = "TENBEGGER";
